module.exports = __webpack_public_path__ + "static/media/Colette Stripe Super King Headboard - 200 cm.78d18f51.jpg";